import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import lodashCompact from 'lodash/fp/compact';

import { SCREEN_ID_UTILITY_SETUP_LOGIN } from 'client/constants/screenIds';

import { SR_API_ACTION_UTILITY_LOGIN } from 'api/utilityActionTypes';

import { hasRoleRenter } from 'common/utility/userRoles';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import branch from 'client/core/branch';
import UtilityActivationActions from 'client/actions/UtilityActivation';
import UtilityAuthActions from 'client/actions/UtilityAuth';
import UtilityPartnerActions from 'client/actions/UtilityPartner';

import SrUtilitySetupPage from 'client/components/SrUtilitySetup/SrUtilitySetupPage';
import SrUtilitySetupLogin from 'client/components/SrUtilitySetup/SrUtilitySetupLogin';

@withTransitionHook
@withScreenId(SCREEN_ID_UTILITY_SETUP_LOGIN)
@withScrollToTop
@branch(({ match }) => {
  const cursors = {
    utilityPartner: ['utilityPartners', 'bySlug', match.params.partnerSlug],
    utilitySetupLoginApiState: ['apiState', SR_API_ACTION_UTILITY_LOGIN, 'default'],
    utilityUser: ['utilityUser'],
  };

  if (match.params.addressId) {
    cursors.utilityActivation = [
      'utilityActivations',
      'byAddressId',
      parseInt(match.params.addressId, 10),
    ];
  }

  return cursors;
})
class UtilitySetupVerifyPhonePage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Utility Setup | Login',
  });

  static fetchData(match, inject) {
    const addressId = parseInt(match.params.addressId, 10);

    return Promise.all(
      lodashCompact([
        UtilityPartnerActions.getBySlug(inject, {
          slug: match.params.partnerSlug,
        }),
        addressId &&
          UtilityActivationActions.getByAddressId(inject, {
            addressId: addressId,
          }),
      ]),
    );
  }

  _onSubmit = (formValues) => {
    const { dispatch, history, match } = this.props;

    dispatch(UtilityAuthActions.login, formValues).then((user) => {
      if (user) {
        history.push(`/utility-setup/session?partner=${match.params.partnerSlug}`);
      }
    });
  };

  render() {
    const {
      utilityPartner,
      utilitySetupLoginApiState,
      utilityUser,
      utilityActivation,
    } = this.props;

    if (utilityUser?.id && hasRoleRenter(utilityUser?.roles || [])) {
      return <Redirect to="/utility-setup/session" />;
    }

    return (
      <SrUtilitySetupPage
        logoUrl={utilityPartner.logoUrl}
        backButtonText="Back"
        backButtonUrl={`/utility-setup/${utilityPartner.slug}`}
      >
        <SrUtilitySetupLogin
          utilityUser={utilityUser || {}}
          utilityPartner={utilityPartner}
          utilityActivation={utilityActivation}
          onSubmit={this._onSubmit}
          apiState={utilitySetupLoginApiState}
        />
      </SrUtilitySetupPage>
    );
  }
}

UtilitySetupVerifyPhonePage.displayName = 'UtilitySetupVerifyPhonePage';

export default UtilitySetupVerifyPhonePage;
